module.exports = __webpack_public_path__ + "media/images/emp/nist_logo-3c3df8528a9ed8a9c5fbfc7cfc80f724.png";